<template>
    <div
        class="w-full md:w-1/2 lg:w-1/3 flex flex-initial cursor-pointer"
        @click="handleAddressSelection">
        <div class="border border-black bg-white m-2 py-3 px-5 flex-initial w-full font-thin text-left">
            <div v-text="fullName" class="font-bold"></div>
            <div v-if="address.house_number" v-text="address.house_number"></div>
            <div v-text="address.address1"></div>
            <div v-text="streetName"></div>
            <div v-if="address.address2 && address.address2.length" v-text="address.address2"></div>
            <div v-text="address.postcode"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GiftingAddressItem',
    props: {
        address: {
            required: true,
            type: Object,
        },
    },
    methods: {
        handleAddressSelection() {
            this.$store.commit('address/updateSelectedGiftingAddressId', this.address.id);
            this.$store.dispatch('gifting/fetchAvailableDeliveryDay');
            this.$emit('address-selected');
        },
    },
    computed: {
        fullName() {
            return `${this.address.first_name} ${this.address.last_name}`;
        },
        streetName() {
            return `${this.address.address1}, ${this.address.house}`;
        },
    },
};
</script>
